import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=12abaff2&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=ts"
export * from "./Certificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12abaff2",
  null
  
)

export default component.exports